import React, { useEffect, useState } from "react";
import { FloatingLabel, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import InputText from "../../input/inputText";
import ModalAddLocation from "./ModalAddLocation";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsAskLocation,
  setIsLocation,
  setLocationMessage,
  setRule,
} from "../../../redux/slices/settings";
import LocationPoints from "./LocationPoints";
import { InfoIcon } from "./../svg";

const LocationAccess = () => {
  const { isLocation, isAskLocation, rule, locationMessage, points, lang } =
    useSelector((state) => ({
      isLocation: state.settings.location.isLocation,
      isAskLocation: state.settings.location.isAskLocation,
      rule: state.settings.location.rule,
      locationMessage: state.settings.location.locationMessage,
      points: state.settings.location.points,
      lang: state.changeLang.language.restriction,
    }));
  const dispatch = useDispatch();

  const [isShowModal, setIsShowModal] = useState(false);
  const [editPointId, setEditPointId] = useState(null);

  const handleClose = () => {
    setIsShowModal(false);
    setEditPointId(null);
  };

  const handleShow = () => {
    setIsShowModal(true);
  };

  const editPoint = (id) => {
    setEditPointId(id);
    setIsShowModal(true);
  };

  useEffect(() => {
    dispatch(setIsAskLocation(!!points.length));
  }, [points]);

  return (
    <>
      {isShowModal && (
        <ModalAddLocation handleClose={handleClose} editPointId={editPointId} />
      )}
      <div className="mb-4">
        <div>
          <Form.Check
            type="checkbox"
            label={lang[4]}
            checked={isLocation}
            onChange={() => dispatch(setIsLocation(!isLocation))}
            id="locationAccess`"
            className="me-2 d-inline-block fw-bold"
          />
          <OverlayTrigger
            overlay={<Tooltip className="opacity-75">{lang[5]}</Tooltip>}
          >
            <div className="d-inline">
              <InfoIcon className="mb-1" />
            </div>
          </OverlayTrigger>
        </div>
        {isLocation && (
          <div className="mt-3">
            <Form.Check
              type="switch"
              label={lang[6]}
              checked={isAskLocation}
              onChange={() => dispatch(setIsAskLocation(!isAskLocation))}
              id="askLocation"
            />
            <FloatingLabel label={lang[7]} className="mt-3">
              <Form.Select
                value={rule}
                onChange={(e) => dispatch(setRule(Number(e.target.value)))}
              >
                <option value={1}>{lang[8]}</option>
                <option value={0}>{lang[9]}</option>
              </Form.Select>
            </FloatingLabel>
            <div
              className="cursor-pointer text-primary mt-3"
              onClick={handleShow}
            >
              + {lang[10]}
            </div>

            <LocationPoints editPoint={editPoint} />

            <InputText
              placeholder={lang[11]}
              popoverText={null}
              className="mb-0 mt-4"
              value={locationMessage}
              onChange={(e) => dispatch(setLocationMessage(e.target.value))}
              maxLength="255"
              disabled={!points.length}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default LocationAccess;
